export default {
  formId: 'createNovedadTurnoForm', //'createNovedadTurnoForm',
  formField: {
   
    
    colaborador: {
      name: 'colaborador',
      label: 'Colaborador*',
      requiredErrorMsg: 'Colaborador  es requerido.'
    },
    responsable: {
      name: 'responsable',
      label: 'Responsable*',
      requiredErrorMsg: 'Responsable  es requerido.'
    },
    tipoNovedad: {
      name: 'tipoNovedad',
      label: 'Tipo Novedad*',
      requiredErrorMsg: 'Tipo Novedad  es requerido.'
    },
    fechaNovedad: {
      name: 'fechaNovedad',
      label: 'Fecha Novedad*',
      requiredErrorMsg: 'Fecha Novedad  es requerido.'
    },
    horaNovedad: {
      name: 'horaNovedad',
      label: 'Hora Novedad*',
      requiredErrorMsg: 'Hora Novedad  es requerido.'
    },
    description: {
      name: 'description',
      label: 'Descripcion*',
      requiredErrorMsg: 'Descripcion es requerido.'
    },
    accion_1: {
      name: 'accion_1',
      label: 'Accion 1*',
      requiredErrorMsg: 'Accion es requerido.'
    }

  }
};
